import { useAuthStore } from '@stores/auth.store';
import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';


/**
 * Forces users with `organization.is_onboarding_complete === false` to the
 * `/onboarding` wizard. Super admins (no organization) bypass automatically.
 */
export function OnboardingGuard({ children }: { children: ReactNode }): JSX.Element {
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const organization = useAuthStore((s) => s.organization);

  // Super admins have no org and never run the onboarding flow.
  if (user?.role === 'super_admin') return <>{children}</>;

  if (organization && !organization.is_onboarding_complete && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }
  return <>{children}</>;
}
